/**
 * Phase 5c — Header layout 이 없는 페이지에서 사용자가 갇히지 않게.
 * MfaSetup, MfaChallenge, NotFound 등에 우측 상단 fixed 배치.
 */
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/useAuthStore';

export function LogoutButton({ inline = false }: { inline?: boolean }) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  if (!user) return null;

  const onClick = async () => {
    await logout();
    toast.success('로그아웃 됐습니다');
    navigate('/login');
  };

  if (inline) {
    return (
      <Button variant="ghost" size="sm" onClick={onClick} className="gap-2">
        <LogOut className="size-4" />
        로그아웃
      </Button>
    );
  }
  return (
    <div className="absolute right-4 top-4 z-50">
      <Button variant="outline" size="sm" onClick={onClick} className="gap-2">
        <LogOut className="size-4" />
        로그아웃 ({user.email ?? user.name})
      </Button>
    </div>
  );
}
